import IconProps, { StyledG } from './IconProps';

function FeedbackIcon({ color = 'primary' }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-615 -432)">
					<path d="M629.625 445.5v4.5l-4.5-4.5h-6.75c-1.864 0-3.375-.948-3.375-2.812v-7.313a3.375 3.375 0 013.375-3.375h11.25a3.375 3.375 0 013.375 3.375v7.313c0 1.864-1.511 2.812-3.375 2.812zm2.25-10.125a2.25 2.25 0 00-2.25-2.25h-11.25a2.25 2.25 0 00-2.25 2.25v7.313c0 1.243 1.007 1.687 2.25 1.687H628.5h-2.813l2.813 2.813v-2.813h1.125c1.243 0 2.25-.445 2.25-1.688v-7.312zm-3.375 4.5a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm-4.5 0a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm-4.5 0a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default FeedbackIcon;
